import {BaseCollection} from 'landing.collection.basecollection';

/**
 * @memberOf BX.Landing.UI.Collection
 */
export class PanelCollection extends BaseCollection {}